import { render, staticRenderFns } from "./AccountSettingSubscription.vue?vue&type=template&id=656e501e"
import script from "./AccountSettingSubscription.vue?vue&type=script&lang=js"
export * from "./AccountSettingSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports